import React from "react";
import classNames from "classnames/bind";
import styles from "./styles.module.scss";
import NeedsGrid from "./NeedsGrid";
import { MEAL_NAME } from "./format";
import { TGrid, TMealKey } from "./types";

const cn = classNames.bind(styles);

interface IOwnNumbersSwitch {
  meal: TMealKey;
  own: TGrid | undefined;
  onUseOwn: () => void;
  onUseShared: () => void;
  onChange: (weekday: string, need: string, value: number) => void;
}

/** Per ticked meal: "uses the shared numbers" (+ link) or its own grid (+ link back). */
const OwnNumbersSwitch: React.FC<IOwnNumbersSwitch> = ({
  meal,
  own,
  onUseOwn,
  onUseShared,
  onChange,
}) =>
  own ? (
    <div className={cn("own")}>
      <div className={cn("own-head")}>
        <b>{MEAL_NAME[meal]}: its own numbers</b>
        <button type="button" className={cn("link")} onClick={onUseShared}>
          Use the shared numbers
        </button>
      </div>
      <NeedsGrid scope={meal} grid={own} onChange={onChange} />
    </div>
  ) : (
    <div className={cn("own-row")}>
      <span>{MEAL_NAME[meal]} uses the shared numbers.</span>
      <button type="button" className={cn("link")} onClick={onUseOwn}>
        Use different numbers for this meal
      </button>
    </div>
  );

export default OwnNumbersSwitch;
